import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NgbDate, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from 'app/shared/configs/custom-date-parse-formatter';
import { I18nSpanish } from 'app/shared/configs/i18n-spanish';
import { createValueAccessorProvider } from 'app/shared/utils/createValueAccessorProvider';
import { dateToNgbDate } from 'app/shared/utils/ngBootstrap';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    { provide: NgbDatepickerI18n, useClass: I18nSpanish },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    createValueAccessorProvider(DatePickerComponent)
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  public today: NgbDate
  public date: NgbDate | null = null

  @Input() public disabled: boolean = false
  @Input() public placeholder: string = 'dd-mm-aaaa'
  @Input() public ngClass: NgClass['klass']
  @Input() public required: boolean = false
  @Input() public clearText: string = 'Limpiar selección'
  @Input() public minDate: NgbDateStruct
  @Input() public maxDate: NgbDateStruct

  @Output() public changeEmitter: EventEmitter<NgbDate | null> = new EventEmitter<NgbDate | null>()

  ngOnInit(): void {
    this.today = this.getToday()
  }

  private onChange: (value: NgbDate | null) => void = () => { }
  private onTouched: () => void = () => { }

  private getToday(): NgbDate {
    const today = new Date()

    return dateToNgbDate(today)
  }

  private toNgbDate(value: any): NgbDate | null {
    if (!value) return null

    if (value.year && value.month && value.day)
      return new NgbDate(value.year, value.month, value.day)

    if (value instanceof Date)
      return dateToNgbDate(value)

    return null
  }

  public emitChanges(): void {
    const date = this.date

    this.changeEmitter.emit(date)

    this.onChange(date)
  }

  public onBlur(): void {
    this.onTouched()
  }

  public clearInput(): void {
    this.date = null

    this.emitChanges()
  }

  public isDisabledDate(date: NgbDate, current: { year: number, month: number }): boolean {
    return date.month !== current.month
  }

  public writeValue(value: any): void {
    this.date = this.toNgbDate(value)

    if (value instanceof Date && this.date)
      this.onChange(this.date)
  }

  public registerOnChange(fn: (value: NgbDate | null) => void): void {
    this.onChange = fn
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
